import React, { useState } from "react";
import { AiTwotoneAppstore } from "react-icons/ai";
import SubNav from "./SubNav";
import ScrollUp from "./ScrollUp";

function BottomNavbar() {
  const [reveal, setReveal] = useState(true);

  return (
    <div className="relative">
      <ScrollUp />
      <div
        className={`border-t-2 bg-gray-50  border-gray-300 fixed bottom-0 poppins lg:hidden z-10 
     w-full ${reveal ? "h-[10vh]" : "h-[35vh] rounded-xl"}
     transition-all duration-75 ease-linear
     z-50`}
      >
        <div className="lg:hidden w-11/12 h-full bg-gray-50 mx-auto  ">
          {reveal ? (
            <div className="items-center h-full flex justify-between transition-all duration-75">
              <h1 className="font-medium">Kumar</h1>
              <div
                onClick={() => {
                  setReveal(!reveal);
                }}
              >
                <AiTwotoneAppstore fontSize={"1.5rem"} />
              </div>
            </div>
          ) : (
            <div className="flex items-start pt-10 relative h-full">
              <SubNav setReveal={setReveal} reveal={reveal} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BottomNavbar;
